export default "__VITE_ASSET__111ee829__"